import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { PopoverPosition } from 'react-tiny-popover';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../../../../web/components/HoverCard';
import { InfoIcon } from '../../../../web/components/svgs/icons/InfoIcon';
import { StarIcon } from '../../../../web/components/svgs/icons/StarIcon';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IAccountDetailsInfoFieldProps
	extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	disabled?: boolean;
	editingStyles?: StyleDeclarationValue[];
	fillColor?: string;
	info?: string | React.ReactNode;
	isEditMode?: boolean;
	label: React.ReactNode;
	labelStyles?: StyleDeclarationValue[];
	placement?: Exclude<PopoverPosition, 'custom'>[];
	styles?: StyleDeclarationValue[];
	symbol?: string;
	valueStyles?: StyleDeclarationValue[];
	isNew?: boolean;
}

export const AccountDetailsInfoField: React.FC<IAccountDetailsInfoFieldProps> = props => {
	const {
		className,
		disabled,
		label,
		styles,
		placement,
		fillColor,
		labelStyles,
		valueStyles,
		children,
		isEditMode,
		editingStyles,
		info,
		isNew,
		...restProps
	} = props;
	return (
		<div
			{...restProps}
			className={`${className || ''} ${css(styleSheet.infoFieldContainer, ...(styles || []))} ${
				isEditMode ? css(styleSheet.infoFieldEditing, ...(editingStyles || [])) : ''
			} `}
		>
			{!!label && (
				<div className={`${css(styleSheet.infoFieldLabel, baseStyleSheet.truncateText, ...(labelStyles || []))}`}>
					{isNew ? (
						<span className={css(styleSheet.infoFieldLabelNewIcon, ...(labelStyles || []))}>
							New <StarIcon filled fillColor='currentColor' />
						</span>
					) : null}{' '}
					{label}
					{info && (
						<HoverCard>
							<HoverCardTrigger className={css(styleSheet.infoIcon)}>
								<InfoIcon fillColor={fillColor || ''} />
							</HoverCardTrigger>
							<HoverCardContent styles={[styleSheet.infoMessage]}>{info}</HoverCardContent>
						</HoverCard>
					)}
				</div>
			)}
			{!!children && <div className={`${css(styleSheet.infoFieldValue, ...(valueStyles || []))}`}>{children}</div>}
		</div>
	);
};
